import { SCHEDULE } from "@/constants/testIds";
import { useLang } from "@/i18n/LanguageContext";
import { CallaLilyFlourish, RoseFlourish } from "@/components/wedding/Flourish";
import { motion } from "framer-motion";
import { Reveal } from "@/components/motion/Reveal";

export const Schedule = () => {
  const { t } = useLang();
  const heading = t("schedule.heading");
  const items = t("schedule.items") || [];

  return (
    <section id="schedule" data-testid={SCHEDULE.section} className="relative py-24 sm:py-32 overflow-hidden">
      <CallaLilyFlourish
        className="absolute -top-6 -right-6 w-[100px] sm:w-[140px] md:w-[180px]"
        opacity={0.85}
      />
      <RoseFlourish
        className="absolute -bottom-8 -left-6 w-[100px] sm:w-[140px] md:w-[180px] rotate-6"
        opacity={0.8}
      />
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid grid-cols-1 md:grid-cols-12 gap-12">
        <Reveal className="md:col-span-4">
          <div className="md:sticky md:top-28">
            <h2 className="mt-4 font-display text-5xl sm:text-6xl tracking-tighter font-light">
              {heading[0]}
              <em className="italic">{heading[1]}</em>
              {heading[2]}
            </h2>
            <p className="mt-6 font-serif italic text-lg text-black/70 max-w-sm">{t("schedule.sub")}</p>
            <p className="mt-4 font-overline text-[10px] text-[color:var(--sunset-600)]">{t("schedule.subNote")}</p>
          </div>
        </Reveal>

        <div className="md:col-span-8">
          <ol className="relative">
            <div className="absolute left-[88px] sm:left-[120px] top-2 bottom-2 w-px bg-black/15" aria-hidden />
            {items.map((item, idx) => (
              <motion.li
                key={item.key}
                data-testid={SCHEDULE.item(item.key)}
                className="relative grid grid-cols-[80px_24px_1fr] sm:grid-cols-[112px_24px_1fr] gap-4 sm:gap-6 py-7 border-b border-black/10 last:border-b-0"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px 0px" }}
                transition={{ duration: 0.7, delay: idx * 0.08, ease: [0.22, 1, 0.36, 1] }}
              >
                <div className="font-mono-acc text-sm tracking-wider text-black/70 pt-1">{item.time}</div>
                <div className="flex justify-center pt-2">
                  <span className="w-2.5 h-2.5 rounded-full bg-[color:var(--sunset-500)] ring-4 ring-white" />
                </div>
                <div>
                  <div className="font-title text-2xl sm:text-3xl tracking-tight">{item.title}</div>
                  <div className="font-sans text-sm text-black/60 mt-1">{item.desc}</div>
                </div>
              </motion.li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
